import React, { useMemo, useEffect } from 'react';
import { UserPermissionsHandler } from '@components-shared/errorHandling/userErrorHandling';
import { ROLES } from 'global.enums';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';

export const GuardUserPermissions = observer(({ children, role }: { role: ROLES; children: React.ReactNode }) => {
  const {
    accountStore: { initialUserInfo },
    authStore,
  } = useMobxStore();

  const userPermissionsHandler = useMemo(
    () => new UserPermissionsHandler(initialUserInfo, role),
    [initialUserInfo, role],
  );

  useEffect(() => {
    if (!userPermissionsHandler.hasPermission()) {
      userPermissionsHandler.showNotification();
      return;
    }
  }, [initialUserInfo, userPermissionsHandler]);

  useEffect(() => {
    authStore.startAuthCookieExpirationDateCheckListener();

    return () => {
      authStore.startAuthCookieExpirationDateCheckListener();
    };
  }, [authStore]);

  return userPermissionsHandler?.hasPermission() ? <>{children}</> : <></>;
});
